/*
# Copyright (c) 2013 inSORS Integrated Communications, All Rights Reserved
#
# This file May not be reproduced or transmitted without explicit permission
# BY ACCESSING OR USING THIS FILE YOU ARE AGREEING TO THE TERMS OF THE INSORS
# SOFTWARE LICENSE POSTED AT: http://www.insors.com/swlicense/
*/

import $ from "jquery";

function BridgeNode(
  server,
  type,
  meeting_code,
  email,
  notificationCallback,
  log,
  mjwt
) {
  if (type === "audio") {
    this.type = "4";
  } else {
    this.type = "6";
  }

  this.base_url = `https://${server}/ig.sdp/${this.type}`;

  const timeout = 30;

  this.log = log || console.log;
  this.meeting_code = meeting_code;
  this.uuid = "";
  this.encryption_key = "";
  this.encryption_type = "";
  this.timeout = timeout; // Notification timeout
  this.in_meeting = false;
  this.notification_xhr = null;
  this.connected = false;
  this.email = email;
  this.notificationCallback = notificationCallback;
  this.nid = `ns${Math.floor(Math.random() * (10000 - 1000) + 999)}`;
  this.mjwt = mjwt;

  return true;
}

BridgeNode.prototype.Setup = function (success, error, rtp_port, rtcp_port) {
  this.log("Sending an RTSP SETUP");
  success = success || function () {};
  error = error || function () {};

  let request_body = "";
  const that = this;
  rtp_port = rtp_port || "13131"; // default
  rtcp_port = rtcp_port || "13132";
  request_body += '"SETUP"';
  const transport = `RTP/AVP/UDP;unicast;client_port=${rtp_port}-${rtcp_port}`;
  $.ajax({
    type: "POST",
    url: `${this.base_url}/${this.meeting_code}/?username=${escape(
      this.email
    )}`,
    beforeSend(request) {
      request.setRequestHeader("Transport", transport);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    contentType: "text",
    data: request_body,
    dataType: "text",
    timeout: 12000,
    success(res, status, xhr) {
      that.connected = true;
      that.log("SUCCESS - RTSP Setup");
      that.session_id = xhr.getResponseHeader("Session");
      that.log(` session id = ${that.session_id}`);
      if (
        that.session_id &&
        that.session_id.length > 0 &&
        that.session_id.indexOf(";") > 0
      ) {
        that.session_id = that.session_id.substring(
          0,
          that.session_id.indexOf(";")
        );
      }
      that.log(` session id = ${that.session_id}`);
      if (that.notificationCallback) {
        that.GetParticipants();
      }
      success(res, status, xhr);
    },
    error(a, b, c) {
      that.log("FAILED - RTSP Setup");
      error(a, b, c);
    },
  });
};

BridgeNode.prototype.ExchangeSdp = function (localSdp, success, error) {
  success = success || function () {};
  error = error || function () {};

  let request_body = "";
  const that = this;

  request_body += '"EXCHANGE-SDP"';
  request_body += `,"${localSdp}"`;

  $.ajax({
    type: "POST",
    url: `${this.base_url}/${this.meeting_code}/bridge/exchange_sdp`,
    beforeSend(request) {
      request.setRequestHeader("Session", that.session_id);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    contentType: "text",
    data: request_body,
    dataType: "text",
    timeout: 12000,
    success(data) {
      that.log("SUCCESS - RTSP ExchangeSdp");
      success(data);
    },
    error(err) {
      that.log("FAILED - RTSP ExchangeSdp");
      error(err);
    },
  });
};

BridgeNode.prototype.Play = function (success, error) {
  success = success || function () {};
  error = error || function () {};

  let request_body = "";
  const that = this;

  request_body += '"PLAY"';
  $.ajax({
    type: "POST",
    url: `${this.base_url}/${this.meeting_code}`,
    beforeSend(request) {
      request.setRequestHeader("Session", that.session_id);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    contentType: "text",
    data: request_body,
    dataType: "text",
    timeout: 12000,
    success(data) {
      that.log("SUCCESS - RTSP Play");
      success();
    },
    error() {
      that.log("FAILED - RTSP Play");
      error();
    },
  });
};

BridgeNode.prototype.SetSwitchedMode = function (value, success, error) {
  success = success || function () {};
  error = error || function () {};
  value = value || "off";

  let request_body = "";
  const that = this;

  request_body += '"SET_PARAMETER"';
  request_body += `,"switchedmode: "${value}`;
  $.ajax({
    type: "POST",
    url: `${this.base_url}/${this.meeting_code}`,
    beforeSend(request) {
      request.setRequestHeader("Session", that.session_id);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    contentType: "text",
    data: request_body,
    dataType: "text",
    timeout: 12000,
    success(data) {
      that.log("SUCCESS - RTSP EnableSwitchedMode ");
      success();
    },
    error() {
      that.log("FAILED -  RTSP EnableSwitchedMode ");
      error();
    },
  });
};

BridgeNode.prototype.Switch = function (value, stream_id, success, error) {
  success = success || function () {};
  error = error || function () {};
  value = value || "on";

  let request_body = "";
  const that = this;
  const hex_value = Number(stream_id).toString(16);
  const command = `,"switch${value}: 0x${hex_value}"`;
  request_body += '"SET_PARAMETER"';
  request_body += command;
  $.ajax({
    type: "POST",
    url: `${this.base_url}/${this.meeting_code}`,
    beforeSend(request) {
      request.setRequestHeader("Session", that.session_id);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    contentType: "text",
    data: request_body,
    dataType: "text",
    timeout: 12000,
    success(data) {
      that.log(`SUCCESS - RTSP Switch -> ${command}`);
      success();
    },
    error() {
      that.log(`FAILED -  RTSP Switch ->${command}`);
      error();
    },
  });
};

// Audio only
BridgeNode.prototype.CreateStream = function (value, success, error) {
  success = success || function () {};
  error = error || function () {};

  let request_body = "";
  const that = this;

  request_body += '"SET_PARAMETER"';
  request_body += `,"create_stream: ${value}"`;
  $.ajax({
    type: "POST",
    url: `${this.base_url}/${this.meeting_code}`,
    beforeSend(request) {
      request.setRequestHeader("Session", that.session_id);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    contentType: "text",
    data: request_body,
    dataType: "text",
    timeout: 12000,
    success(data) {
      that.log("SUCCESS - RTSP Create Stream");
      success();
    },
    error() {
      that.log("FAILED -  RTSP Create Stream");
      error();
    },
  });
};

BridgeNode.prototype.Teardown = function () {
  if (this.notification_xhr) {
    this.notification_xhr.abort();
  }

  if (!this.connected) {
    this.log("Skipping TEARDOWN, RTSP Setup never succeeded");
    return null;
  }

  this.connected = false;

  const that = this;

  return $.ajax({
    type: "POST",
    url: `${this.base_url}/${this.meeting_code}`,
    beforeSend(request) {
      request.setRequestHeader("Session", that.session_id);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    contentType: "text",
    data: '"TEARDOWN"',
    dataType: "text",
    timeout: 12000,
  });
};

BridgeNode.prototype.GetParticipants = function () {
  this.log("BridgeNode.GetParticipants()");
  const that = this;

  $.ajax({
    type: "GET",
    dataType: "text",
    url: `${this.base_url}/${this.meeting_code}/bridge/sources`,
    beforeSend(request) {
      request.setRequestHeader("Session", that.session_id);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    success(data) {
      that.log(" SUCCESS - Get Participants");
      if (that.connected) {
        that.notificationCallback(data);
        that.GetNotifications();
      }
    },
    error() {
      that.log(" FAILED- Get Participants");
    },
  });
};

BridgeNode.prototype.GetNotifications = function () {
  const that = this;
  that.log("BridgeNode.GetNotifications()");

  this.notification_xhr = $.ajax({
    type: "GET",
    cache: false,
    dataType: "text",
    url: `${this.base_url}/${this.meeting_code}/bridge/notify?nid=${
      this.nid
    }&timeout=${this.timeout}&username=${escape(this.email)}`,
    beforeSend(request) {
      request.setRequestHeader("Session", that.session_id);
      request.setRequestHeader("Authorization", `Meeting ${that.mjwt}`);
    },
    success(data, status, xhr) {
      that.log(" SUCCESS - Bridge Node GetNotifications");
      // We keep sending GET to grab notifications(Long polling)
      if (that.connected) {
        that.notificationCallback(data);
        that.GetNotifications();
      }
    },
    timeout: this.timeout * 1000 + 10000, // the timeout plus 10 seconds
    error() {
      that.log("FAILED - Bridge Node GetNotifications ");
    },
  });
};

export default BridgeNode;
